import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getText } from '@storebrand-digital/fms-translations';
import LoadingIndicator from '@storeblocks/loading-indicator';
import Alert from '@storeblocks/alert';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale/nb';
import ErrorComponent from '../../../components/ErrorComponent';
import { ItemsBase, Item, Avatar, Container, LoadingWrap, Title, } from './styled';
import StatusLabel from './statuslabel';
import { getMessageThreadsRequested } from '../redux/threadSlice';
export function formatDateTime(dateString, formatString) {
    if (formatString === void 0) { formatString = "dd.MM.yyyy 'kl.' HH:mm"; }
    return format(parseISO(dateString), formatString, { locale: nb });
}
function Items() {
    var search = useLocation().search;
    var _a = useState(0), offset = _a[0], setOffset = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return state.messageThreads; }), _c = _b.getMessageThreadsState, loading = _c.loading, error = _c.error, records = _b.records;
    var totalSize = 20;
    useEffect(function () {
        dispatch(getMessageThreadsRequested({ limit: 20, offset: offset }));
    }, [offset, dispatch]);
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        var lastCase = document.querySelector("#case-".concat(records ? records.length - 1 : 0));
        if (lastCase) {
            var observer_1 = new IntersectionObserver(function (_a) {
                var e = _a[0];
                if (e.isIntersecting && totalSize === 20) {
                    setOffset(records.length);
                }
            }, {
                threshold: 1,
            });
            observer_1.observe(lastCase);
            return function () { return observer_1.unobserve(lastCase); };
        }
    }, [records]);
    var statusAvatars = {
        NEW: 'light-bulb',
        ON_HOLD: 'hourglass',
        CLOSED: 'clipboard-check',
    };
    var relatedCaseLabel = function (relatedCase) {
        return relatedCase.number
            ? "".concat(relatedCase.subject, " ref ").concat(relatedCase.number)
            : "".concat(relatedCase.subject);
    };
    function renderContent() {
        if (error) {
            return React.createElement(ErrorComponent, { error: { status: 404 } });
        }
        if ((records === null || records === void 0 ? void 0 : records.length) === 0) {
            return (React.createElement(Alert, { title: getText('inbox.messages.empty'), variant: "info", fluid: true }));
        }
        return (React.createElement(React.Fragment, null, records === null || records === void 0 ? void 0 :
            records.map(function (_a, index) {
                var _b, _c;
                var id = _a.id, relatedCase = _a.relatedCase, unreadMessages = _a.unreadMessages;
                return (React.createElement(Item, { to: "/meldinger/".concat(id).concat(search), id: "case-".concat(index), key: id },
                    React.createElement(Avatar, { "$hasUnread": unreadMessages > 0, name: (_c = statusAvatars[(_b = relatedCase.status) === null || _b === void 0 ? void 0 : _b.caseStatus]) !== null && _c !== void 0 ? _c : 'speech-bubble' }),
                    React.createElement(Container, null,
                        React.createElement(StatusLabel, { status: relatedCase.status, lastModifiedDate: formatDateTime(relatedCase.lastModifiedDate) }),
                        React.createElement("span", null, relatedCaseLabel(relatedCase)))));
            }),
            loading && (React.createElement(LoadingWrap, null,
                React.createElement(LoadingIndicator, null)))));
    }
    return (React.createElement(ItemsBase, null,
        React.createElement(Title, null, getText('inbox.title')),
        renderContent()));
}
export default Items;
